import { useState, useEffect, useRef } from 'react';

interface BitcoinPrice {
  usd: number;
  brl: number;
}

const REFRESH_INTERVAL = 60_000; // 1 minute

export function useBitcoinPrice() {
  const [price, setPrice] = useState<BitcoinPrice | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const timerRef = useRef<ReturnType<typeof setInterval> | null>(null);

  const fetch_ = async () => {
    try {
      const res = await fetch(
        'https://api.coingecko.com/api/v3/simple/price?ids=bitcoin&vs_currencies=usd,brl'
      );
      if (!res.ok) throw new Error('fetch failed');
      const data = await res.json() as { bitcoin: BitcoinPrice };
      setPrice(data.bitcoin);
      setError(false);
    } catch {
      setError(true);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetch_();
    timerRef.current = setInterval(fetch_, REFRESH_INTERVAL);
    return () => {
      if (timerRef.current) clearInterval(timerRef.current);
    };
  }, []);

  return { price, loading, error };
}
